import { css } from '@emotion/react';
import IconX from '~icons/bx/x';
import { theme } from '@arc/frontend/ui-theme';
const styles = {
  icon: /*#__PURE__*/css({
    color: theme.colors.icons.default,
    width: '1.5rem',
    height: '1.5rem'
  }, process.env.NODE_ENV === "production" ? "" : ";label:icon;"),
  inlineButton: /*#__PURE__*/css({
    backgroundColor: theme.colors.white,
    display: 'grid',
    width: '2rem',
    height: '2rem',
    cursor: 'pointer',
    placeItems: 'center',
    borderBottomLeftRadius: '0.375rem',
    borderBottomRightRadius: '0.375rem',
    filter: 'drop-shadow(0px 8px 12px #0000001f);'
  }, process.env.NODE_ENV === "production" ? "" : ";label:inlineButton;")
};
export function ButtonCancelInline(props) {
  return <button type="button" {...props} css={styles.inlineButton}>
			<IconX css={styles.icon} />
		</button>;
}